import { t } from 'decentraland-dapps/dist/modules/translation'
import { IconBadge } from 'decentraland-ui/dist/components/IconBadge/IconBadge'

export const UtilityBadge = () => <IconBadge text={t('global.utility')} icon="utility" />
